import { defineComponent, PropType } from "vue";
import { Container } from "aurelia-dependency-injection";

import { ToastrService } from "../../../../../../services/toastr.service";
import { IProblems } from "../../../../../../resources-vue/vue-interfaces/i-problems";

import TableEmpty from "../../../../../../resources-vue/vue-custom-elements/TableEmpty/TableEmpty.vue";
import ProblemsTableRow from "./ProblemsTableRow.vue";

export default defineComponent({
    components: {
        TableEmpty,
        ProblemsTableRow
    },
    props: {
        id: {
            type: String
        },
        updateProblems: {
            type: Function
        },
        problems: {
            type: Array as PropType<IProblems[]>,
            default: []
        },
        application: {
            type: Number
        }
    },
    data(vm) {
        return {
            newProblems: [] as IProblems[],
            _toastrService: null,
            isNewTerminal: false,
            columns: 5,
            isAddRequested: true
        };
    },
    created() {
        this._toastrService = Container.instance.get(ToastrService);
    },
    mounted() {
        if (this.problems.length) {
            let temp = [
                ...this.problems.filter((d: any) => !d.resolvedDate).sort((a: any, b: any) => a.order - b.order),
                ...this.problems.filter((d: any) => d.resolvedDate)
            ];
            this.updateProblems(temp);
        }
        if (this.problems && this.problems[0] && this.problems[0].order != 1) {
            let temp = Array(this.problems[0].order - 1)
                .fill(null)
                .concat(this.problems);
            this.updateProblems(temp);
        }
    },
    computed: {
        activeProblems() {
            if (this.problems.length > 0) {
                return this.problems
                    .filter((problem: any) => !problem.resolvedDate)
                    .map((problem: any, index) => {
                        problem.order = index + 1;

                        return problem;
                    });
            }
            return [];
        }
    },
    methods: {
        updateProblem(value: any, index: number) {
            let temp = [...this.newProblems];
            temp = temp.map((el, idx) => {
                if (idx === index) {
                    return value;
                } else {
                    return el;
                }
            });
            this.newProblems = temp;
        },
        addProblem() {
            if (this.problems.length == 0) {
                this.isNewTerminal = true;
            } else {
                this.isNewTerminal = false;
            }
            this.newProblems.push({
                code: "",
                description: "",
                associatedTaskId: "",
                order: null,
                onsetDate: null,
                isPresentOnAdmission: null,
                isDeprecated: null,
                resolvedDate: null
            });
        },
        saveNewProblem(index: number) {
            let arr = this.problems;
            this.newProblems[index].order = this.problems.length + 1;
            arr.push(this.newProblems[index]);
            this.newProblems.splice(index, 1);
            let temp = [...arr.filter((d) => !d.resolvedDate), ...arr.filter((d) => d.resolvedDate)];
            this.updateProblems(temp);
        },

        deleteProblem(index: number) {
            if (this.problems.length >= 1) {
                this.problems.splice(index, 1);
                let temp = this.problems.map((problem: IProblems, probIdx) => {
                    if (!problem.resolvedDate) {
                        problem.order = probIdx + 1;
                    }
                    return problem;
                });
                this.updateProblems(temp);
            }
        },
        resolveProblem(index: number) {
            if (this.problems.length > 0 && index <= this.problems.length) {
                let orderCount = 1;
                let temp = this.problems.map((problem) => {
                    if (!problem.resolvedDate) {
                        problem.order = orderCount;
                        orderCount++;
                    }
                    return problem;
                });
                this.updateProblems(temp);
            }
        },
        cancelSaveNewProblem(index: number) {
            this.newProblems.splice(index, 1);
        },
        moveProblem(oldIndex: number, newIndex: number) {
            let arr = this.problems;
            if (oldIndex >= arr.length || oldIndex < 0) {
                return;
            }
            if (newIndex >= arr.length || newIndex < 0) {
                return;
            }
            arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
            arr = arr.map((problem: IProblems, index) => {
                if (!problem.resolvedDate) {
                    problem.order = index + 1;
                }
                return problem;
            });
            let temp = arr;
            this.updateProblems(temp);
        }
    }
});
